import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const consolidatedPositionLiquidityEnum = {
  NotInformed: 0,
  D1: 1,
  D2: 2,
  D3: 3,
  D6: 4,
  D31: 5,
};

export type ConsolidatedPositionLiquidityEnum =
  (typeof consolidatedPositionLiquidityEnum)[keyof typeof consolidatedPositionLiquidityEnum];

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo', flex: 2 },
  { title: 'Valor  bruto', flex: 1.2 },
  { title: 'Valor investido', flex: 1.2 },
  { title: 'Quantidade' },
  { title: 'Rentabilidade' },
];
